import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import imageSizes from 'decorators/imageSizes'

import s from './Image.scss'


const Image = (props) => {
  const { className, src, srcSet, fullWidth, alt, itemProp, draggable, dataTestId } = props

  const imgClassName = cx(className, {
    [s.fullWidth]: fullWidth,
  })

  return (
    <img
      className={imgClassName}
      src={src}
      srcSet={srcSet}
      alt={alt}
      itemProp={itemProp}
      draggable={draggable}
      data-testid={dataTestId}
    />
  )
}

Image.propTypes = {
  className: PropTypes.string,
  src: PropTypes.string.isRequired,
  srcSet: PropTypes.string,
  fullWidth: PropTypes.bool,
  alt: PropTypes.string,
  itemProp: PropTypes.string,
  draggable: PropTypes.bool,
  dataTestId: PropTypes.string,
}

Image.defaultProps = {
  alt: '',
}


export default imageSizes()(Image)
